import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react';
import { render } from 'react-dom'
import {
    Input, Label, FormGroup, Row, Col, Button, InputGroup, InputGroupAddon
} from "reactstrap";
import { ComboBox, DropdownBox } from "../../../dropdowns";
import { DatePicker } from "../../../date-pickers";
import { formatDate, formatDateZeroTime } from "../../../../utils";
import moment from "moment";
import InputMask from "react-input-mask";
import { PhotoDropzone } from '../../../FileDropzone';
import { ListBox, processListBoxData } from '@progress/kendo-react-listbox';
import ReactStars from 'react-stars'
import { debounce } from "lodash";
import api from '../../../../services/api';
import Multiselect from 'multiselect-react-dropdown';
import { TooltipButton } from '../../../inputs';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { v4 } from 'uuid';
import { PhoneNumberRenderer } from './Renderers/PhoneNumberRenderer';
import TerminationReviewResult from './TerminationReviewResult';
import { DefaultColumnFilter } from '../../../react-table/filters';
import { useExpanded, useFilters, useFlexLayout, useSortBy, useTable } from 'react-table';
import Grid from '../../../Grid';
import "../../../../assets/css/ag-grid.css";
import "../../../../assets/css/ag-theme-alpine.css";
import { AgGridReact } from 'ag-grid-react';
import EditorResidencyValidation from '../EditorResidencyValidation';
import SweetAlert from 'react-bootstrap-sweetalert';
import Select from 'react-select';
import chroma from 'chroma-js';
    
const onGridReady = (params) => {
    params.api.sizeColumnsToFit();
    window.addEventListener('resize', () => {
        params.api.sizeColumnsToFit(); // refit on window resize
    });
};

function mypassRequirementRenderer(props) {
    const {data} = props;

    const defaultAgGridColDef = {
        resizable: true,
        filter: false,
        suppressPaste: true,
        suppressFillHandle: true,
        sortable: true,
        suppressMenu: true,
        editable: false,
        flex: 1,
    };

    const complianceCertificateColumns = [
            {
                field: "name",
                headerName: "Certificate",
                cellRenderer: "agGroupCellRenderer",
                width: 500
            },
            {
                field: "dateAttained",
                headerName: "Date Attained",
                valueFormatter: (params) => {
                    const { value } = params;
                    return value ? moment(value).format("DD.MM.YYYY") : "N/A";
                },
            },
            {
                field: "expiryDate",
                headerName: "Expiry Period",
                valueFormatter: (params) => {
                    const { value } = params;
                    return value ? moment(value).format("DD.MM.YYYY") : "N/A";
                },
            },
        ];

    const complianceRequirementColumns = data.skillRequirements?.length ?
        [
            {
                field: "name",
                headerName: "Requirement",
                cellRenderer: "agGroupCellRenderer",
                width: 500
            },
            {
                field: "type",
                headerName: "Type",
            },
            {
                field: "mandatory",
                headerName: "Mandatory",
                valueFormatter: () => "",
                cellClass: (params) => {
                    return `roster-cell text-center fas ${params.value ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'}`;
                },
            },
            {
                field: "achieved",
                headerName: "Achieved",
                valueFormatter: () => "",
                cellClass: (params) => {
                    return `roster-cell text-center fas ${params.value ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'}`;
                },
            },
        ]
        :
        [
            {
                field: "name",
                headerName: "Requirement",
                cellRenderer: "agGroupCellRenderer",
                width: 500
            },
            {
                field: "type",
                headerName: "Type",
            },
            {
                field: "achieved",
                headerName: "Achieved",
                valueFormatter: () => "",
                cellClass: (params) => {
                    return `roster-cell text-center fas ${params.value ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'}`;
                },
            },
        ];

    const gridParam = data?.requisites?.length ? {
            columnDefs: complianceCertificateColumns,
            defaultColDef: defaultAgGridColDef,
            rowData: data.requisites.map(r => ({...r.certification})),
            suppressClipboardPaste: true,
            headerHeight: 25,
            groupHeaderHeight: 22,
            rowHeight: 22,
            onGridReady,
            animateRows: true,
        }
        :
        {
            columnDefs: complianceRequirementColumns,
            defaultColDef: defaultAgGridColDef,
            rowData: data.skillRequirements ?? data.childRequirements?.map(c => ({...c.child})) ?? [],
            suppressClipboardPaste: true,
            headerHeight: 25,
            groupHeaderHeight: 22,
            rowHeight: 22,
            onGridReady,
            animateRows: true,
            detailCellRenderer: mypassRequirementRenderer,
            masterDetail: true,
            isRowMaster: (data) => {
                return (
                    (data?.skillRequirements?.length > 0) ||
                    (data?.childRequirements?.length > 0) ||
                    (data?.requisites?.length > 0)
                );
            },
        };

    return (
        <AgGridReact {...gridParam}/>
    );
};

export default function Profile(props) {
    const {
        itemInEdit,
        setItemInEdit,
        setSmsFromContact,
        setEmailFromContact,
        isSaving,
        lookups: {phoneTypes, atsiStatuses, detailedCandidateTypes},
        setActiveTab,
    } = props;

    const candidateTypeValues = useMemo(() => {
        const result = detailedCandidateTypes?.length ? detailedCandidateTypes.filter(ct => itemInEdit?.candidateTypes?.filter(c => c.typeId === ct.candidateTypeId)?.length > 0) : [];

        if (!result.length)
            return result;

        result.sort((a, b) => {
            return itemInEdit?.candidateTypes?.filter(c => c.typeId === a.candidateTypeId)[0]?.orderIndex - itemInEdit?.candidateTypes?.filter(c => c.typeId === b.candidateTypeId)[0]?.orderIndex;
        });

        return result;
    }, [detailedCandidateTypes, itemInEdit]);

    // useEffect(() => {
    //     console.log({itemInEdit, detailedCandidateTypes, values: candidateTypeValues});
    // }, [detailedCandidateTypes, itemInEdit]);

    const [communicationTypes, setCommunicationTypes] = useState([]);
    const [profileData, setProfileData] = useState({});
    const [clientList, setClientList] = useState([]);
    const [alternativeLocationList, setAlternativeLocationList] = useState([]);
    const [loadingClient, setLoadingClient] = useState(false);
    const [candidatePhoneInEdit, setCandidatePhoneInEdit] = useState(null);
    const [terminationReviewResults, setTerminationReviewResults] = useState([]);
    const [showTerminationReviewResults, setShowTerminationReviewResults] = useState(false);

    useEffect(() => {
        if (!profileData?.candidateId)
            return;

        api.get(`termination/detail/employee/employeeassessments/latest/${profileData.candidateId}`)
            .then((response) => {
                setTerminationReviewResults(response.data);
            })
            .catch((error) => console.error({error}))
        ;
    }, [profileData?.candidateId]);
    
    const [dispatchUnitList, setDispatchUnitList] = useState([]);
    const [residencyValidationEditorParams, setResidencyValidationEditorParams] = useState(null);
    const [messageDialogObj, setMessageDialogObj] = useState(null);
    const skipPageResetEmergencyContactRef = useRef();
    const skipPageResetAllocationHistoryRef = useRef();
    const skipPageResetDispatchHistoryRef = useRef();
    const complianceRef = useRef();

    useEffect(() => {
        skipPageResetEmergencyContactRef.current = true;
        skipPageResetAllocationHistoryRef.current = true;
        skipPageResetDispatchHistoryRef.current = true;
    }, []);

    useEffect(() => {
        if (!itemInEdit || (profileData.candidateId !== undefined && !itemInEdit.firstLoadProfile) || !itemInEdit.firstLoadProfile)
            return;

        const {
            candidateId,
            photoFileName,
            photoFileType,
            photoFileContent,
            firstName,
            middleName,
            surname,
            preferredName,
            salutation,
            salutationId,
            maritalStatus,
            maritalStatusId,
            universalStudentID,
            naturalPosition,
            naturalPositionId,
            gender,
            genderId,
            doB,
            atsi,
            disability,
            cald,
            mobilePhoneNumber,
            receivingCommunication,
            receivingEmail,
            receivingSms,
            preferredCommunication,
            preferredCommunicationId,
            email,
            receivingPhoneCall,
            residencyStatus,
            residencyStatusId,
            nationality,
            visaNumber,
            visaExpiryDate,
            candidateType,
            candidateTypeId,
            candidateStatus,
            candidateStatusId,
            agency,
            agencyId,
            defaultProject,
            defaultProjectId,
            fasttrackCandidateNo,
            mainAddressLine1,
            mainAddressLine2,
            mainAddressCountry,
            mainAddressCountryId,
            mainAddressState,
            mainAddressStateId,
            mainAddressCity,
            mainAddressPostcode,
            mailingAddressSameAsMain,
            mailAddressLine1,
            mailAddressLine2,
            mailAddressCountry,
            mailAddressCountryId,
            mailAddressState,
            mailAddressStateId,
            mailAddressCity,
            mailAddressPostcode,
            emergencyContactName,
            emergencyContactPhone,
            relationshipToCandidate,
            relationshipToCandidateId,
            modifiedBy,
            modifiedDate,
            candidateClientExclusions,
            candidateClientInclusions,
            performanceRating,
            alternativeLocation,
            alternativeLocationId,
            contractingCompany,
            contractingCompanyId,
            emergencyContacts,
            complianceResults,
            candidateAllocations,
            dispatchHistory,
            residencyValidated,
            residencyValidatedBy,
            residencyValidationDate,
            atsiStatus,
        } = itemInEdit;

        setProfileData({
            candidateId,
            photoFileName,
            photoFileType,
            photoFileContent,
            firstName,
            middleName,
            surname,
            preferredName,
            salutation,
            salutationId,
            maritalStatus,
            maritalStatusId,
            universalStudentID,
            naturalPosition,
            naturalPositionId,
            gender,
            genderId,
            doB,
            atsi,
            disability,
            cald,
            mobilePhoneNumber,
            receivingCommunication,
            receivingEmail,
            receivingSms,
            preferredCommunication,
            preferredCommunicationId,
            email,
            receivingPhoneCall,
            residencyStatus,
            residencyStatusId,
            nationality,
            visaNumber,
            visaExpiryDate,
            candidateType,
            candidateTypeId,
            candidateStatus,
            candidateStatusId,
            agency,
            agencyId,
            defaultProject,
            defaultProjectId,
            fasttrackCandidateNo,
            mainAddressLine1,
            mainAddressLine2,
            mainAddressCountry,
            mainAddressCountryId,
            mainAddressState,
            mainAddressStateId,
            mainAddressCity,
            mainAddressPostcode,
            mailingAddressSameAsMain,
            mailAddressLine1,
            mailAddressLine2,
            mailAddressCountry,
            mailAddressCountryId,
            mailAddressState,
            mailAddressStateId,
            mailAddressCity,
            mailAddressPostcode,
            emergencyContactName,
            emergencyContactPhone,
            relationshipToCandidate,
            relationshipToCandidateId,
            modifiedBy,
            modifiedDate,
            candidateClientExclusions,
            candidateClientInclusions,
            performanceRating,
            alternativeLocation,
            alternativeLocationId,
            contractingCompany,
            contractingCompanyId,
            emergencyContacts,
            complianceResults,
            candidateAllocations,
            dispatchHistory,
            residencyValidated,
            residencyValidatedBy,
            residencyValidationDate,
            atsiStatus,
        });

        setItemInEdit({...itemInEdit, firstLoadProfile: false});
    }, [itemInEdit]);

    const refreshDispatchData = useCallback(() => {
        setDispatchUnitList([]);

        if (!profileData?.dispatchHistory?.length)
            return;

        const now = new Date();
        setDispatchUnitList(profileData?.dispatchHistory.filter(d => d.nullableEndDate ? (new Date(moment(d.nullableEndDate).format("YYYY-MM-DD")) >= now) : false));
    }, [profileData?.candidateId]);

    useEffect(() => {
        if (!profileData?.dispatchHistory?.length)
            return;

        refreshDispatchData();
    }, [profileData?.dispatchHistory]);

    React.useEffect(() => {
        setCommunicationTypes(props.lookups.communicationTypes?.filter(o => {
            if (o.lookupValue === "Phone" && profileData.receivingPhoneCall) return true;
            if (o.lookupValue === "Email" && profileData.receivingEmail) return true;
            if (o.lookupValue === "SMS" && profileData.receivingSms) return true;
            return false;
        }));

    }, [profileData.receivingEmail, profileData.receivingPhoneCall, profileData.receivingSms, props.lookups.communicationTypes]);

    useEffect(() => {
        if (!isSaving)
            return;

        setItemInEdit({ ...itemInEdit, ...profileData });
    }, [isSaving]);

    const handleTextChanged = ({ target: { name, value } }) => {
        setProfileData({ ...profileData, [name]: value });
    }

    const ratingChanged = (ratingChanged) => {
        setProfileData({ ...profileData, performanceRating: ratingChanged });
    }

    const handleDateChanged = (value, name) => {
        setProfileData({
            ...profileData,
            [name]: !value ? null : formatDateZeroTime(value) //moment(value).format("YYYY-MM-DDT00:00:00") 
        });
    }

    const onClientsFilterChangeMultiselect = (value) => {
        getClients(value);
    }
    
    const getClients = React.useCallback(debounce((filter='') => {
        // if (!filter || filter.length === 0) return;
        setLoadingClient(true);
        api.get(`/client/search?filter=${filter}`)
            .then(({ data }) => {
                // setPositions([...data.map(d => ({...d, combinedName: `${d.hrispositionName} (${d.position.lookupValue})`}))]);
                setClientList(data);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => setLoadingClient(false));
    }, 200), [clientList]);

    const onClientInclusionChangeMultiselect = useCallback((values) => {
        var newList = values.map((v, i, a) => ({ ...v, candidateId: itemInEdit.candidateId }));
        setProfileData({ ...profileData, candidateClientInclusions: newList });
    }, [profileData]);
    const onClientInclusionRemoveMultiselect = (newList) => {
        onClientInclusionChangeMultiselect([...newList]);
        getClients('');
    }

    const onClientExclusionChangeMultiselect = useCallback((values) => {
        var newList = values.map((v, i, a) => ({ ...v, candidateId: itemInEdit.candidateId }));
        setProfileData({ ...profileData, candidateClientExclusions: newList });
    }, [profileData]);
    const onClientExclusionRemoveMultiselect = (newList) => {
        onClientExclusionChangeMultiselect([...newList]);
        getClients('');
    }

    useEffect(() => {
        getClients('');
        getAlternativeLocation();
    }, []);

    const getAlternativeLocation = React.useCallback((filter = '') => {

        api.get(`/alternativelocation/search?filter=${filter}`)
            .then(({ data }) => {
                // setPositions([...data.map(d => ({...d, combinedName: `${d.hrispositionName} (${d.position.lookupValue})`}))]);
                setAlternativeLocationList(data);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => { });
    }, [alternativeLocationList]);

    useEffect(() => {
        if (!candidatePhoneInEdit?.isRemoval)
            return;

        const {candidatePhones} = itemInEdit;
        const newPhoneNumbers = JSON.parse(JSON.stringify(candidatePhones));
        const deleted = newPhoneNumbers.filter(p => p.uid === candidatePhoneInEdit.uid)[0];

        if (!deleted)
            return;

        newPhoneNumbers.splice(newPhoneNumbers.indexOf(deleted), 1);
        const newRemovedCandidatePhones = [...itemInEdit?.removedCandidatePhones];

        if (deleted.candidatePhoneId)
            newRemovedCandidatePhones.push(deleted);

        setItemInEdit({...itemInEdit, candidatePhones: newPhoneNumbers, removedCandidatePhones: newRemovedCandidatePhones});
    }, [candidatePhoneInEdit]);

    const phoneNumberRenderer = useMemo(() => {
        if (!itemInEdit?.candidatePhones)
            return null;

        const {candidatePhones} = itemInEdit;

        if (!candidatePhones?.length)
            return null;

        return (
            <ListBox
                data={candidatePhones ?? []}
                item={(props) => PhoneNumberRenderer({
                    ...props,
                    phoneTypes,
                    onDataChanged: (val, isRemoval = false) => {
                        if (isRemoval)
                        {
                            setCandidatePhoneInEdit({...val, isRemoval});
                            return;
                        }

                        const updated = candidatePhones.filter(p => p.uid === val.uid)[0];
                
                        if (!updated)
                        {
                            setItemInEdit({...itemInEdit, candidatePhones: candidatePhones});
                            return;
                        }
                        
                        candidatePhones.splice(candidatePhones.indexOf(updated), 1, {...val});
                        setItemInEdit({...itemInEdit, candidatePhones: candidatePhones});
                    },
                    onSendSms: (p) => {
                        setSmsFromContact([{...profileData, mobilePhoneNumber: p.phoneNumber}]);
                    },
                })}
                style={{
                    width: "100%",
                    height: "22vh"
                }}
                className="border-0"
            />
        );
    }, [itemInEdit?.candidatePhones, profileData, phoneTypes]);
    
    const filterTypes = React.useMemo(() => ({
        text: (rows, id, filterValue) => {
            return rows.filter(row => {
                const rowValue = row.values[id]
                return rowValue !== undefined
                    ? String(rowValue).replace(/[/-]/g, "")
                        .toLowerCase()
                        .includes(String(filterValue).replace(/[/-]/g, "").toLowerCase())
                    : true
            })
        },
    }), []);

    const defaultColumn = React.useMemo(() => ({
        width: 150,
        Filter: DefaultColumnFilter,
        filter: "text",
        disableSortBy: true,
        disableFilters: true,
    }), []);

    const defaultEmergencyContactSort = useMemo(() => [{ id: "contactName", desc: false }],
        []
    );

    const emergencyContactColumns = useMemo(() => {
        return [
            {
                Header: "Contact Name",
                id: "contactName",
                accessor: "contactName",
                Filter: DefaultColumnFilter,
                filter: "text",
                width: 100,
            },
            {
                Header: "Relation",
                id: "relation",
                accessor: "relation",
                Filter: DefaultColumnFilter,
                filter: "text",
                width: 100,
            },
            {
                Header: "Phone Number",
                id: "phoneNumber",
                accessor: "phoneNumber",
                Filter: DefaultColumnFilter,
                filter: "text",
                width: 100,
            },
        ];
    }, []);

    const {
        getTableProps: getEmergencyContactTableProps,
        getTableBodyProps: getEmergencyContactTableBodyProps,
        headerGroups: emergencyContactHeaderGroups,
        rows: emergencyContactRows,
        prepareRow: prepareEmergencyContactRow,
        state: emergencyContactState,
    } = useTable(
        {
            columns: emergencyContactColumns,
            data: profileData?.emergencyContacts ?? [],
            initialState: {
                sortBy: defaultEmergencyContactSort,
                canSort: true,
            },
            filterTypes,
            defaultColumn,
            manualSortBy: true,
            autoResetPage: !skipPageResetEmergencyContactRef.current,
            autoResetExpanded: !skipPageResetEmergencyContactRef.current,
            autoResetGroupBy: !skipPageResetEmergencyContactRef.current,
            autoResetSelectedRows: !skipPageResetEmergencyContactRef.current,
            autoResetSortBy: !skipPageResetEmergencyContactRef.current,
            autoResetFilters: !skipPageResetEmergencyContactRef.current,
            autoResetRowState: !skipPageResetEmergencyContactRef.current,
        },
        useFlexLayout,
        useFilters,
        useSortBy,
        useExpanded
    );

    const defaultAgGridColDef = useMemo(() => ({
        resizable: true,
        filter: false,
        suppressPaste: true,
        suppressFillHandle: true,
        sortable: true,
        suppressMenu: true,
        editable: false,
        flex: 1,
    }), []);

    const complianceColumns = useMemo(() => {
        return [
            {
                field: "position",
                headerName: "Position",
                cellRenderer: "agGroupCellRenderer",
            },
            {
                field: "skillsMatrix",
                headerName: "Skill",
            },
            {
                field: "compliancePercent",
                headerName: "Compliance (%)",
                cellStyle: { textAlign: "right" },
                valueFormatter: (params) => {
                    if (params.value === null || isNaN(params.value)) return "N/A";
                    return Number(params.value).toFixed(2);
                }
            },
        ];
    }, []);

    const complianceRequirementColumns = useMemo(() => {
        return [
            {
                field: "name",
                headerName: "Requirement",
                cellRenderer: "agGroupCellRenderer",
                width: 500
            },
            {
                field: "type",
                headerName: "Type",
            },
            {
                field: "achieved",
                headerName: "Achieved",
                valueFormatter: () => "",
                cellClass: (params) => {
                    return `roster-cell text-center fas ${params.value ? 'fa-check-circle text-success' : 'fa-times-circle text-danger'}`;
                },
            },
        ];
    }, []);

    const allocationHistoryColumns = React.useMemo(() => {
        const colArray = [
            {
                Header: "Entity",
                accessor: "company.companyName",
            },
            {
                Header: "Project",
                accessor: "project.projectName",
            },
            {
                Header: "Position",
                accessor: "position.positionName",
            },
            {
                Header: "Start Date",
                accessor: (row) => row.startDate ? moment(row.startDate).format("DD/MM/YYYY") : "",
            },
        ];

        return colArray;
    }, []);

    const {
        getTableProps: getAllocationHistoryTableProps,
        getTableBodyProps: getAllocationHistoryTableBodyProps,
        headerGroups: getAllocationHistoryHeaderGroups,
        rows: allocationHistoryRows,
        prepareRow: prepareAllocationHistoryRow,
    } = useTable(
        {
            columns: allocationHistoryColumns,
            data: profileData.candidateAllocations?.filter(d => d.active) ?? [],
            autoResetPage: !skipPageResetAllocationHistoryRef.current,
            autoResetExpanded: !skipPageResetAllocationHistoryRef.current,
            autoResetGroupBy: !skipPageResetAllocationHistoryRef.current,
            autoResetSelectedRows: !skipPageResetAllocationHistoryRef.current,
            autoResetSortBy: !skipPageResetAllocationHistoryRef.current,
            autoResetFilters: !skipPageResetAllocationHistoryRef.current,
            autoResetRowState: !skipPageResetAllocationHistoryRef.current,
            defaultColumn,
        },
        useFlexLayout
    );

    const dispatchHistoryColumns = React.useMemo(() => {
        const colArray = [
            {
                Header: "Entity",
                accessor: "companyName",
            },
            {
                Header: "Project",
                accessor: "projectName",
            },
            {
                Header: "Position",
                accessor: "positionName",
            },
            {
                Header: "Start Date",
                accessor: (row) => row.nullableStartDate ? moment(row.nullableStartDate).format("DD/MM/YYYY") : "",
            },
        ];

        return colArray;
    }, []);

    const {
        getTableProps: getDispatchHistoryTableProps,
        getTableBodyProps: getDispatchHistoryTableBodyProps,
        headerGroups: getDispatchHistoryHeaderGroups,
        rows: dispatchHistoryRows,
        prepareRow: prepareDispatchHistoryRow,
    } = useTable(
        {
            columns: dispatchHistoryColumns,
            data: dispatchUnitList ?? [],
            autoResetPage: !skipPageResetDispatchHistoryRef.current,
            autoResetExpanded: !skipPageResetDispatchHistoryRef.current,
            autoResetGroupBy: !skipPageResetDispatchHistoryRef.current,
            autoResetSelectedRows: !skipPageResetDispatchHistoryRef.current,
            autoResetSortBy: !skipPageResetDispatchHistoryRef.current,
            autoResetFilters: !skipPageResetDispatchHistoryRef.current,
            autoResetRowState: !skipPageResetDispatchHistoryRef.current,
            defaultColumn,
        },
        useFlexLayout
    );

    const colourStyles = {
        container: (styles) => ({
            ...styles,
            height: 'auto',
            minHeight: 'auto',
        }),
        control: (styles) => ({
            ...styles,
            backgroundColor: 'white',
            minHeight: 'calc(0.5em + 1.25rem + 2px)',
            height: 'auto',
            alignItems: 'flex-start',
        }),
        valueContainer: (styles) => ({
            ...styles,
            paddingTop: 0,
            paddingBottom: 0,
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: 4,
            height: 'auto',
            boxSizing: 'border-box',
        }),
        input: (styles) => ({
            ...styles,
            margin: 0,
        }),
        option: (styles, { data, isSelected }) => {
            const dataColor = data.themeColor ?? '#fff';
            const color = chroma(dataColor);
            return {
                ...styles,
                backgroundColor: isSelected ? dataColor : color.alpha(0.8).css(),
                color: (chroma.contrast(color, 'white') > 2 ? 'white' : 'black'),
                ':active': {
                    ...styles[':active'],
                    backgroundColor: isSelected ? dataColor : color.alpha(1).css(),
                },
            };
        },
        multiValue: (styles, { data }) => {
            const dataColor = data.themeColor ?? '#fff';
            const color = chroma(dataColor);
            return {
                ...styles,
                backgroundColor: color.alpha(0.8).css(),
                color: (chroma.contrast(color, 'white') > 2 ? 'white' : 'black'),
                margin: 2,
            };
        },
        multiValueLabel: (styles, { data }) => {
            const dataColor = data.themeColor ?? '#fff';
            const color = chroma(dataColor);
            return {
                ...styles,
                color,
            };
        },
        multiValueRemove: (styles, { data }) => {
            const dataColor = data.themeColor ?? '#fff';
            const color = chroma(dataColor);
            return {
                ...styles,
                color,
                ':hover': {
                    backgroundColor: color,
                    color: 'white',
                },
            };
        },
        indicatorsContainer: (styles) => ({
            ...styles,
            minHeight: 'calc(0.5em + 1.25rem + 2px)',
            height: "auto",
            alignItems: 'center',
        }),
        dropdownIndicator: (styles) => ({
            ...styles,
            padding: "0 4px",
            minHeight: 'calc(0.5em + 1.25rem + 2px)',
            height: "auto",
            display: 'flex',
            alignItems: 'center',
            alignSelf: 'stretch',
        }),
        indicatorSeparator: (styles) => ({
            ...styles,
            minHeight: 'calc(0.5em + 1.25rem + 2px)',
            height: "auto",
            display: 'none',
        }),
    };

    return (
        <>
            <Row className="m-0 p-0">
                <Col lg={6} xs={12} className="border-right border-light">
                    <Row className="m-0 p-0">
                        <Col lg={12} xs={12} className="font-weight-bold w-100 border-bottom border-primary mx-0 my-2 p-0">
                            Profile
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    First Name
                                </Label>
                                <Input
                                    name="firstName"
                                    id="firstName"
                                    type="text"
                                    required
                                    value={profileData.firstName ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Middle Name
                                </Label>
                                <Input
                                    name="middleName"
                                    id="middleName"
                                    type="text"
                                    required
                                    value={profileData.middleName ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Surname
                                    <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    name="surname"
                                    id="surname"
                                    type="text"
                                    required
                                    value={profileData.surname ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Preferred Name
                                </Label>
                                <Input
                                    name="preferredName"
                                    id="preferredName"
                                    type="text"
                                    required
                                    value={profileData.preferredName ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Salutation
                                </Label>
                                <DropdownBox
                                    data={props.lookups.salutations}
                                    selectedItem={profileData.salutation || {}}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, salutation: item, salutationId: item ? item.lookupId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label for="universalStudentID">
                                    Universal Student ID
                                </Label>
                                <Input
                                    name="universalStudentID"
                                    id="universalStudentID"
                                    type="text"
                                    value={profileData.universalStudentID ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="h-100 m-0 p-0">
                            <FormGroup>
                                <Label for="atsi">
                                    ATSI
                                </Label>
                                {/* <label className="custom-toggle custom-toggle-primary d-block">
                                    <Input
                                        type="checkbox"
                                        name="atsi"
                                        id="atsi"
                                        checked={profileData.atsi || false}
                                        onChange={({ target: { checked } }) => setProfileData({ ...profileData, atsi: checked })}
                                    />
                                    <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                                </label> */}
                                <DropdownBox
                                    data={atsiStatuses}
                                    selectedItem={profileData.atsiStatus || {}}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, atsiStatus: item, atsiStatusId: item ? item.lookupId : null });
                                    }}
                                    id="atsi"
                                />
                            </FormGroup>
                        </Col>
                        {/* <Col xs={2} className="h-100">
                            <FormGroup className="">
                                <Label for="disability">
                                    Disability
                                </Label>
                                <label className="custom-toggle custom-toggle-primary d-block">
                                    <Input
                                        type="checkbox"
                                        name="disability"
                                        id="disability"
                                        checked={profileData.disability || false}
                                        onChange={({ target: { checked } }) => setProfileData({ ...profileData, disability: checked })}
                                    />
                                    <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                                </label>
                            </FormGroup>
                        </Col>
                        <Col xs={2} className="h-100">
                            <FormGroup className="">
                                <Label for="cald">
                                    CALD
                                </Label>
                                <label className="custom-toggle custom-toggle-primary d-block">
                                    <Input
                                        type="checkbox"
                                        name="cald"
                                        id="cald"
                                        checked={profileData.cald || false}
                                        onChange={({ target: { checked } }) => setProfileData({ ...profileData, cald: checked })}
                                    />
                                    <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                                </label>
                            </FormGroup>
                        </Col> */}
                        <Col lg={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Default Project
                                </Label>
                                <ComboBox
                                    endpoint="/project/search"
                                    isLookup={false}
                                    idField="projectId"
                                    valueField="projectName"
                                    selectedItem={profileData.defaultProject}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, defaultProject: item, defaultProjectId: item ? item.projectId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Gender
                                </Label>
                                <DropdownBox
                                    data={props.lookups.genders}
                                    selectedItem={profileData.gender || {}}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, gender: item, genderId: item ? item.lookupId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    DOB
                                </Label>
                                <DatePicker
                                    name="doB"
                                    id="doB"
                                    type="text"
                                    required
                                    value={formatDate(profileData.doB)}
                                    onChange={handleDateChanged}
                                    closeOnSelect
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Natural Position
                                </Label>
                            {
                                profileData.employeeNumber ?
                                <Input
                                    name="latestAllocatedPositionName"
                                    id="latestAllocatedPositionName"
                                    type="text"
                                    value={profileData.latestAllocatedPosition?.positionName ?? ""}
                                    disabled
                                />
                                :
                                <Input
                                    name="naturalPositionInitial"
                                    id="naturalPositionInitial"
                                    type="text"
                                    value={profileData.naturalPositionInitial ?? ""}
                                    onChange={handleTextChanged}
                                />
                            }
                                {/* <ComboBox
                                    minLength={0}
                                    endpoint="/position/search"
                                    isLookup={false}
                                    idField="positionId"
                                    valueField="positionName"
                                    selectedItem={profileData.naturalPosition}
                                    onChange={(selectedItem) => setProfileData({
                                        ...profileData,
                                        naturalPosition: selectedItem,
                                        naturalPositionId: selectedItem?.positionId
                                    })}
                                /> */}
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={12} xs={12} className="font-weight-bold w-100 border-bottom border-primary mx-0 my-2 p-0">
                            Contact
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={6} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Mobile Number
                                </Label>
                                <InputGroup>
                                    <InputMask
                                        name="mobilePhoneNumber"
                                        id="mobilePhoneNumber"
                                        type="tel"
                                        required
                                        value={profileData.mobilePhoneNumber ?? ""}
                                        onChange={handleTextChanged}
                                        className="form-control"
                                        mask={process.env.REACT_APP_MOBILE_FORMAT}
                                        alwaysShowMask={false}
                                        formatChars={{ '0': '[0-9X]' }}
                                        onFocus={(event) => event.currentTarget.select()}
                                    />
                                    <div className="input-group-append">
                                        <TooltipButton
                                            color="default"
                                            disabled={!profileData?.mobilePhoneNumber || profileData.mobilePhoneNumber === ""}
                                            onClick={() => setSmsFromContact([profileData])}
                                            id="send-sms"
                                            title="Send SMS"
                                        >
                                            <i className="fas fa-paper-plane" />
                                        </TooltipButton>
                                    </div>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col lg={6} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Email
                                </Label>
                                <InputGroup>
                                    <Input
                                        name="email"
                                        id="email"
                                        type="email"
                                        required
                                        //readOnly
                                        value={profileData.email ?? ""}
                                        onChange={handleTextChanged}
                                    />
                                    <div className="input-group-append">
                                        <TooltipButton
                                            color="default"
                                            disabled={!profileData?.email || profileData.email === ""}
                                            onClick={() => setEmailFromContact([profileData])}
                                            id="send-email"
                                            title="Send Email"
                                        >
                                            <i className="fas fa-paper-plane" />
                                        </TooltipButton>
                                    </div>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={12} xs={12} className="font-weight-bold w-100 border-bottom border-primary mx-0 my-2 p-0">
                            Other Phone Numbers
                        </Col>
                        <Col lg={12} className="m-0 p-0">
                            <TooltipButton
                                id="addnew"
                                title="Add New"
                                className="btn-icon mb-2"
                                color="default"
                                size="sm"
                                type="button"
                                onClick={() => {
                                    const newNumbers = [...(itemInEdit?.candidatePhones ?? []), {
                                        candidatePhoneId: 0,
                                        phoneType: null,
                                        phoneTypeId: null,
                                        phoneNumber: null,
                                        uid: v4(),
                                    }];
                                    setItemInEdit({...itemInEdit, candidatePhones: [...newNumbers]});
                                }}
                            >
                                <i className="fas fa-plus pt-1"></i>
                            </TooltipButton>
                        </Col>
                        {/* <Col lg={6} xs={12}>
                            <Row>
                                <Col lg={6} xs={12}>
                                    <FormGroup className="">
                                        <Label for="receivingCommunication">
                                            Receive Communication
                                        </Label>
                                        <label className="custom-toggle custom-toggle-primary d-block">
                                            <input type="checkbox"
                                                name="receivingCommunication"
                                                id="receivingCommunication"
                                                checked={profileData.receivingCommunication || false}
                                                onChange={({ target: { checked } }) => {
                                                    setProfileData({
                                                        ...profileData,
                                                        receivingCommunication: checked,
                                                        receivingEmail: !checked ? false : profileData.receivingEmail,
                                                        receivingSms: !checked ? false : profileData.receivingSms,
                                                        preferredCommunication: !checked ? null : profileData.preferredCommunication,
                                                        preferredCommunicationId: !checked ? null : profileData.preferredCommunicationId
                                                    });

                                                }}
                                            />
                                            <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                                        </label>
                                    </FormGroup>
                                </Col>
                                <Col lg={6} xs={12}>
                                    <FormGroup className="">
                                        <Label for="receivingEmail">
                                            Receive Email
                                        </Label>
                                        <label className="custom-toggle custom-toggle-primary d-block">
                                            <input type="checkbox"
                                                name="receivingEmail"
                                                id="receivingEmail"
                                                checked={profileData.receivingEmail || false}
                                                disabled={!profileData.receivingCommunication}
                                                onChange={({ target: { checked } }) => setProfileData({ ...profileData, receivingEmail: checked })}
                                            />
                                            <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                                        </label>
                                    </FormGroup>
                                </Col>
                                <Col lg={6} xs={12}>
                                    <FormGroup className="">
                                        <Label for="receivingPhoneCall">
                                            Receive Phone Call
                                        </Label>
                                        <label className="custom-toggle custom-toggle-primary d-block">
                                            <input type="checkbox"
                                                name="receivingPhoneCall"
                                                id="receivingPhoneCall"
                                                checked={profileData.receivingPhoneCall || false}
                                                disabled={!profileData.receivingCommunication}
                                                onChange={({ target: { checked } }) => setProfileData({ ...profileData, receivingPhoneCall: checked })}
                                            />
                                            <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                                        </label>
                                    </FormGroup>
                                </Col>
                                <Col lg={6} xs={12}>
                                    <FormGroup className="">
                                        <Label for="receivingSms">
                                            Receive SMS
                                        </Label>
                                        <label className="custom-toggle custom-toggle-primary d-block">
                                            <input type="checkbox"
                                                name="receivingSms"
                                                id="receivingSms"
                                                checked={profileData.receivingSms || false}
                                                disabled={!profileData.receivingCommunication}
                                                onChange={({ target: { checked } }) => setProfileData({ ...profileData, receivingSms: checked })}
                                            />
                                            <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                                        </label>
                                    </FormGroup>
                                </Col>
                                <Col lg={12}>
                                    <FormGroup>
                                        <Label>
                                            Preffered Communication Type
                                        </Label>
                                        <DropdownBox
                                            data={communicationTypes}
                                            selectedItem={profileData.preferredCommunication || {}}
                                            disabled={!profileData.receivingCommunication}
                                            onChange={(item) => {
                                                setProfileData({ ...profileData, preferredCommunication: item, preferredCommunicationId: item ? item.lookupId : null });
                                            }}
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col> */}
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={12} className="font-weight-bold w-100 border-bottom border-primary mx-0 my-2 p-0">
                            Main Address
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Main Address Line 1
                                </Label>
                                <Input
                                    name="mainAddressLine1"
                                    id="mainAddressLine1"
                                    type="text"
                                    value={profileData.mainAddressLine1 ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Main Address Line 2
                                </Label>
                                <Input
                                    name="mainAddressLine2"
                                    id="mainAddressLine2"
                                    type="text"
                                    value={profileData.mainAddressLine2 ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Country
                                </Label>
                                <DropdownBox
                                    data={props.lookups.countries}
                                    selectedItem={profileData.mainAddressCountry || {}}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, mainAddressCountry: item, mainAddressCountryId: item ? item.lookupId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    State
                                </Label>
                                <DropdownBox
                                    data={props.lookups.states}
                                    selectedItem={profileData.mainAddressState || {}}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, mainAddressState: item, mainAddressStateId: item ? item.lookupId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    City
                                </Label>
                                <Input
                                    name="mainAddressCity"
                                    id="mainAddressCity"
                                    type="text"
                                    value={profileData.mainAddressCity ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={3} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Postcode
                                </Label>
                                <Input
                                    name="mainAddressPostcode"
                                    id="mainAddressPostcode"
                                    type="text"
                                    value={profileData.mainAddressPostcode ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={12} className="m-0 p-0">
                            <FormGroup className="d-flex flex-wrap align-items-center">
                                <Label for="mailingAddressSameAsMain" className="mr-3 my-0">
                                    Mailing address same as Main
                                </Label>
                                <label className="custom-toggle custom-toggle-primary">
                                    <Input
                                        type="checkbox"
                                        name="mailingAddressSameAsMain"
                                        id="mailingAddressSameAsMain"
                                        checked={profileData.mailingAddressSameAsMain || false}
                                        onChange={({ target: { checked } }) => setProfileData({ ...profileData, mailingAddressSameAsMain: checked })}
                                    />
                                    <span className="custom-toggle-slider rounded-circle" data-label-off="No" data-label-on="Yes"></span>
                                </label>
                            </FormGroup>
                        </Col>
                    </Row>
                {
                    profileData && !profileData.mailingAddressSameAsMain ?
                    <>
                        <Row className="m-0 p-0">
                            <Col lg={12} className="font-weight-bold w-100 border-bottom border-primary mx-0 my-2 p-0">
                                Mailing Address
                            </Col>
                        </Row>
                        <Row className="m-0 p-0">
                            <Col xs={12} className="m-0 p-0">
                                <FormGroup>
                                    <Label>
                                        Mailing Address Line 1
                                    </Label>
                                    <Input
                                        name="mailAddressLine1"
                                        id="mailAddressLine1"
                                        type="text"
                                        value={profileData.mailAddressLine1 ?? ""}
                                        disabled={profileData.mailingAddressSameAsMain}
                                        onChange={handleTextChanged}
                                    />
                                </FormGroup>
                            </Col>
                            <Col xs={12} className="m-0 p-0">
                                <FormGroup>
                                    <Label>
                                        Mailing Address Line 2
                                    </Label>
                                    <Input
                                        name="mailAddressLine2"
                                        id="mailAddressLine2"
                                        type="text"
                                        value={profileData.mailAddressLine2 ?? ""}
                                        disabled={profileData.mailingAddressSameAsMain}
                                        onChange={handleTextChanged}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg={3} xs={12} className="m-0 p-0">
                                <FormGroup>
                                    <Label>
                                        Country
                                    </Label>
                                    <DropdownBox
                                        data={props.lookups.countries}
                                        selectedItem={profileData.mailAddressCountry || {}}
                                        disabled={profileData.mailingAddressSameAsMain}
                                        onChange={(item) => {
                                            setProfileData({ ...profileData, mailAddressCountry: item, mailAddressCountryId: item ? item.lookupId : null });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg={3} xs={12} className="m-0 p-0">
                                <FormGroup>
                                    <Label>
                                        State
                                    </Label>
                                    <DropdownBox
                                        data={props.lookups.states}
                                        selectedItem={profileData.mailAddressState}
                                        disabled={profileData.mailingAddressSameAsMain}
                                        onChange={(item) => {
                                            setProfileData({ ...profileData, mailAddressState: item, mailAddressStateId: item ? item.lookupId : null });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg={3} xs={12} className="m-0 p-0">
                                <FormGroup>
                                    <Label>
                                        City
                                    </Label>
                                    <Input
                                        name="mailAddressCity"
                                        id="mailAddressCity"
                                        type="text"
                                        value={profileData.mailAddressCity ?? ""}
                                        disabled={profileData.mailingAddressSameAsMain}
                                        onChange={handleTextChanged}
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg={3} xs={12} className="m-0 p-0">
                                <FormGroup>
                                    <Label>
                                        Postcode
                                    </Label>
                                    <Input
                                        name="mailAddressPostcode"
                                        id="mailAddressPostcode"
                                        type="text"
                                        value={profileData.mailAddressPostcode ?? ""}
                                        disabled={profileData.mailingAddressSameAsMain}
                                        onChange={handleTextChanged}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                    </>
                    :
                    null
                }
                    {/* <Row>
                        <Col lg={12} xs={12} className="font-weight-bold w-100 border-bottom border-primary my-2">
                            Preference
                        </Col>
                    </Row>
                    <Row>

                        <Col xs={6}>
                            <FormGroup>
                                <Label className={"stars-label"}>
                                    Performance Rating
                                {
                                    terminationReviewResults?.length ?
                                    <TooltipButton
                                        id="show-performance-rating-detail"
                                        title="See Details"
                                        color="default"
                                        className="btn-icon ml-2"
                                        type="button"
                                        onClick={() => setShowTerminationReviewResults(true)}
                                    >
                                        <i className="fas fa-search"/>
                                    </TooltipButton>
                                    :
                                    null
                                }
                                </Label>
                                <ReactStars
                                    className={"stars-on-profile"}
                                    count={10}
                                    half={false}
                                    size={29}
                                    onChange={ratingChanged}
                                    value={profileData.performanceRating}
                                    color2={'#ffd700'} />
                                <span class={`fa fa-times-circle ${(profileData.performanceRating == null ? "d-none" : "stars-delete")}`} aria-hidden="true" onClick={() => { ratingChanged(null); }}></span>
                            </FormGroup>
                        </Col>
                        <Col xs={6}>
                            <FormGroup>
                                <Label>
                                    Alternative Location
                                </Label>
                                <DropdownBox
                                    data={alternativeLocationList}
                                    selectedItem={profileData.alternativeLocation}
                                    idField="alternativeLocationId"
                                    valueField="alternativeLocationName"
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, alternativeLocation: item, alternativeLocationId: item ? item.alternativeLocationId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={6}>
                            <FormGroup>
                                <Label>
                                    Client Exclusion Preference
                                </Label>

                                <Multiselect
                                    className="slim-search"
                                    options={clientList}
                                    loading={loadingClient}
                                    displayValue="clientName"
                                    placeholder="Type to search"
                                    selectedValues={profileData.candidateClientExclusions}
                                    onSearch={onClientsFilterChangeMultiselect}
                                    onSelect={(selected) => {
                                        onClientExclusionChangeMultiselect(selected);
                                    }}
                                    onRemove={onClientExclusionRemoveMultiselect}
                                    showCheckbox={true}
                                    showArrow={true}
                                    closeOnSelect={true}
                                />
                            </FormGroup>
                        </Col>
                        <Col xs={6}>
                            <FormGroup>
                                <Label>
                                    Client Inclusion Preference
                                </Label>

                                <Multiselect
                                    className="slim-search"
                                    options={clientList}
                                    loading={loadingClient}
                                    displayValue="clientName"
                                    placeholder="Type to search"
                                    selectedValues={profileData.candidateClientInclusions}
                                    onSearch={onClientsFilterChangeMultiselect}
                                    onSelect={(selected) => {
                                        onClientInclusionChangeMultiselect(selected);
                                    }}
                                    onRemove={onClientInclusionRemoveMultiselect}
                                    showCheckbox={true}
                                    showArrow={true}
                                    closeOnSelect={true}
                                />
                            </FormGroup>
                        </Col>
                    </Row> */}
                    <Row className="m-0 p-0">
                        <Col lg={12} className="font-weight-bold w-100 border-bottom border-primary mx-0 my-2 p-0">
                            Emergency Contact
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col xs={12}>
                            <FormGroup>
                                <Label>
                                    Emergency Contact Name
                                </Label>
                                <Input
                                    name="emergencyContactName"
                                    id="emergencyContactName"
                                    type="text"
                                    required
                                    value={profileData.emergencyContactName ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={6} xs={12}>
                            <FormGroup>
                                <Label>
                                    Emergency Contact Phone
                                </Label>
                                <Input
                                    name="emergencyContactPhone"
                                    id="emergencyContactPhone"
                                    type="text"
                                    required
                                    value={profileData.emergencyContactPhone ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={6} xs={12}>
                            <FormGroup>
                                <Label>
                                    Relationship
                                </Label>
                                <DropdownBox
                                    data={props.lookups.relationshipTypes}
                                    selectedItem={profileData.relationshipToCandidate || {}}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, relationshipToCandidate: item, relationshipToCandidateId: item ? item.lookupId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                    </Row> */}
                    <Row className="m-0 p-0">
                        <Col xs={12} className="m-0 p-0">
                            <Grid
                                height="3rem"
                                totalRecords={emergencyContactRows.length}
                                pageSize={emergencyContactRows.length}
                                rows={emergencyContactRows}
                                tableProps={getEmergencyContactTableProps()}
                                headerGroups={emergencyContactHeaderGroups}
                                tableBodyProps={getEmergencyContactTableBodyProps()}
                                prepareRow={prepareEmergencyContactRow}
                                needPaging={false}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col lg={6} xs={12}>
                    <Row className="m-0 p-0">
                        <Col lg={12} xs={12} className="font-weight-bold w-100 border-bottom border-primary mx-0 my-2 p-0">
                            Status
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={6} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Candidate Type
                                </Label>
                                {/* <DropdownBox
                                    data={props.lookups.candidateTypes}
                                    selectedItem={profileData.candidateType}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, candidateType: item, candidateTypeId: item ? item.lookupId : null });
                                    }}
                                /> */}
                                <Select
                                    closeMenuOnSelect={false}
                                    isMulti
                                    options={detailedCandidateTypes}
                                    value={candidateTypeValues}
                                    className="react-select-container"
                                    placeholder="-- Select --"
                                    getOptionLabel={(option) => option.label}
                                    getOptionValue={(option) => option.candidateTypeId}
                                    styles={colourStyles}
                                    onChange={(values) =>{
                                        // console.log({values});
                                        setItemInEdit({
                                            ...itemInEdit,
                                            candidateTypes: values.map((v, idx) => {
                                                return {
                                                    candidateId: itemInEdit.candidateId,
                                                    typeId: v.candidateTypeId,
                                                    orderIndex: idx + 1,
                                                };
                                            }),
                                        });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={6} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Candidate Status
                                </Label>
                                <DropdownBox
                                    data={props.lookups.candidateStatuses}
                                    selectedItem={profileData.candidateStatus}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, candidateStatus: item, candidateStatusId: item ? item.lookupId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        {/* <Col lg={6} xs={12}>
                            <FormGroup>
                                <Label>
                                    Agency
                                </Label>
                                <DropdownBox
                                    data={props.lookups.agencies}
                                    selectedItem={profileData.agency}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, agency: item, agencyId: item ? item.lookupId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={6} xs={12}>
                            <FormGroup>
                                <Label>
                                    Contracting Company
                                </Label>
                                <DropdownBox
                                    data={props.lookups.contractingCompanies}
                                    selectedItem={profileData.contractingCompany}
                                    idField="contractingCompanyId"
                                    valueField="contractingCompanyName"
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, contractingCompany: item, contractingCompanyId: item ? item.contractingCompanyId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={12} xs={12}>
                            <FormGroup>
                                <Label>
                                    External Reference No
                                </Label>
                                <Input
                                    name="fasttrackCandidateNo"
                                    id="fasttrackCandidateNo"
                                    type="number"
                                    className="hide-arrow"
                                    onInput={(e) => e.target.value = e.target.value.slice(0, 9)}
                                    value={profileData.fasttrackCandidateNo ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col> */}
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={12} className="w-100 border-bottom border-primary mx-0 my-2 p-0">
                            <span className="font-weight-bold mr-2">
                                Residency
                            </span>
                            <TooltipButton
                                id="validateResidency"
                                title="Validate"
                                className="btn-icon mb-2"
                                color="default"
                                size="sm"
                                type="button"
                                onClick={() => setResidencyValidationEditorParams(profileData)}
                            >
                                <i className="fas fa-check pt-1"></i>
                            </TooltipButton>
                        {
                            profileData?.residencyValidated ?
                            <span>
                                <i className="text-success fas fa-check pt-1 mr-1"></i>
                                <span className="font-size-small-custom">Verified by {profileData.residencyValidatedBy} at {moment(profileData.residencyValidationDate).format("DD-MM-YYYY HH:mm")}</span>
                            </span>
                            :
                            null
                        }
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Residency Status
                                </Label>
                                <DropdownBox
                                    data={props.lookups.residencyStatuses}
                                    selectedItem={profileData.residencyStatus || {}}
                                    onChange={(item) => {
                                        setProfileData({ ...profileData, residencyStatus: item, residencyStatusId: item ? item.lookupId : null });
                                    }}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Visa Number
                                </Label>
                                <Input
                                    name="visaNumber"
                                    id="visaNumber"
                                    type="text"
                                    required
                                    value={profileData.visaNumber ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Visa Expiry
                                </Label>
                                <DatePicker
                                    name="visaExpiryDate"
                                    id="visaExpiryDate"
                                    type="text"
                                    required
                                    value={formatDate(profileData.visaExpiryDate)}
                                    onChange={handleDateChanged}
                                    closeOnSelect
                                />
                            </FormGroup>
                        </Col>
                        <Col lg={4} xs={12} className="m-0 p-0">
                            <FormGroup>
                                <Label>
                                    Nationality
                                </Label>
                                <Input
                                    name="nationality"
                                    id="nationality"
                                    type="text"
                                    required
                                    value={profileData.nationality ?? ""}
                                    onChange={handleTextChanged}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={6} className="font-weight-bold w-100 border-bottom border-primary mx-0 my-2 p-0">
                            Current Employment
                        </Col>
                        <Col lg={6} className="d-flex flex-wrap justify-content-end align-items-start border-bottom border-primary mx-0 my-2 p-0">
                            <span className="font-size-small-custom cursor-pointer" onClick={() => setActiveTab(11)}><u>See All History</u></span>
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={12} xs={12}>
                            <Grid
                                height="10rem"
                                totalRecords={allocationHistoryRows.length}
                                pageSize={allocationHistoryRows.length}
                                rows={allocationHistoryRows}
                                tableProps={getAllocationHistoryTableProps()}
                                headerGroups={getAllocationHistoryHeaderGroups}
                                tableBodyProps={getAllocationHistoryTableBodyProps()}
                                prepareRow={prepareAllocationHistoryRow}
                                needPaging={false}
                            />
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={6} className="font-weight-bold w-100 border-bottom border-primary mx-0 my-2 p-0">
                            Upcoming Dispatch
                        </Col>
                        <Col lg={6} className="d-flex flex-wrap justify-content-end align-items-start border-bottom border-primary mx-0 my-2 p-0">
                            <span className="font-size-small-custom cursor-pointer" onClick={() => setActiveTab(17)}><u>See All History</u></span>
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={12} xs={12} className="m-0 p-0">
                            <Grid
                                height="15rem"
                                totalRecords={dispatchHistoryRows.length}
                                pageSize={dispatchHistoryRows.length}
                                rows={dispatchHistoryRows}
                                tableProps={getDispatchHistoryTableProps()}
                                headerGroups={getDispatchHistoryHeaderGroups}
                                tableBodyProps={getDispatchHistoryTableBodyProps()}
                                prepareRow={prepareDispatchHistoryRow}
                                needPaging={false}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col lg={12} xs={12}>
                    <Row className="m-0 p-0">
                        <Col lg={6} className="font-weight-bold w-100 border-bottom border-primary mx-0 my-2 p-0">
                            Compliance
                        </Col>
                        <Col lg={6} className="d-flex flex-wrap justify-content-end align-items-start border-bottom border-primary mx-0 my-2 p-0">
                            <span className="font-size-small-custom cursor-pointer" onClick={() => setActiveTab(4)}><u>Show Qualifications</u></span>
                        </Col>
                    </Row>
                    <Row className="m-0 p-0">
                        <Col lg={12} xs={12} className="m-0 p-0">
                            <div
                                className="ag-theme-alpine px-2"
                                style={{
                                    width: '100%',
                                    height: `${((profileData?.complianceResults?.length ?? 0) * 22) + 25}px`,
                                    minHeight: '25rem',
                                }}
                            >
                                <AgGridReact
                                    ref={complianceRef}
                                    rowData={profileData.complianceResults ?? []}
                                    columnDefs={complianceColumns}
                                    defaultColDef={defaultAgGridColDef}
                                    suppressClipboardPaste={true}
                                    headerHeight={25}
                                    groupHeaderHeight={22}
                                    rowHeight={22}
                                    animateRows={true}
                                    detailCellRenderer={mypassRequirementRenderer}
                                    masterDetail={true}
                                    onGridReady={onGridReady}
                                    isRowMaster={(data) => {
                                        return (
                                            (data?.skillRequirements?.length > 0) ||
                                            (data?.childRequirements?.length > 0) ||
                                            (data?.requisites?.length > 0)
                                        );
                                    }}
                                />
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <div className="d-flex ml-3 mt-3 font-size-sm">
                <div>
                    Last Modified By {profileData.modifiedBy} on {new Date(profileData.modifiedDate).toLocaleDateString("en-au", {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: 'numeric',
                        minute: 'numeric'
                    })}
                </div>
            </div>
        {
            residencyValidationEditorParams ?
            <EditorResidencyValidation
                data={residencyValidationEditorParams}
                onClose={() => setResidencyValidationEditorParams(null)}
                onUpload={(attachments) => {
                    setItemInEdit({
                        ...itemInEdit,
                        candidateDocuments: [
                            ...(itemInEdit?.candidateDocuments?.filter(cd => cd.documentType?.lookupValue !== "Residency Validation") ?? []),
                            ...attachments,
                        ],
                        getDataFromResidencyValidation: true,
                    });
                    setResidencyValidationEditorParams(null);
                    setMessageDialogObj({
                        title: "Residency Validation",
                        message: "Upload complete. Check the Documents tab; status will update once you save the form.",
                    });
                }}
            />
            :
            null
        }
        {
            messageDialogObj ?
            <SweetAlert
                success
                confirmBtnText="Ok"
                confirmBtnBsStyle="default"
                title={<span className="mb-0 h4">{messageDialogObj.title}</span>}
                onConfirm={() => setMessageDialogObj(null)}
            >
                {messageDialogObj.message}
            </SweetAlert>
            :
            null
        }
        {
            showTerminationReviewResults ?
            <TerminationReviewResult
                onClose={() => setShowTerminationReviewResults(false)}
                data={terminationReviewResults}
            />
            :
            null
        }
        </>
    )
}